import { InputAdornment, Typography } from "@material-ui/core";
import React from "react";
import {
	AutocompleteInput,
	NumberInput,
	ReferenceInput,
	SimpleForm,
	useTranslate,
} from "react-admin";
import { bookmakersConfig } from "../bookmakers";

const DuplicateForm = ({ duplicateIds, ...props }) => {
	const translate = useTranslate();
	return (
		<SimpleForm
			{...props}
			redirect="list"
			initialValues={{
				duplicateIds,
			}}
		>
			<>
				<Typography variant="caption" color="textSecondary">
					{translate(
						"resources.bookmaker-deals.bulk-actions.clone_all.description"
					)}
				</Typography>
			</>
			<ReferenceInput
				source="bookmaker_id"
				reference="bookmakers"
				fullWidth
				{...bookmakersConfig.reference}
				resettable
			>
				<AutocompleteInput
					optionText="name"
					emptyText={translate(
						"resources.bookmaker-deals.fields.bookmaker.all"
					)}
				/>
			</ReferenceInput>
			<ReferenceInput
				source="user_id"
				reference="users"
				fullWidth
				resettable
				allowEmpty
			>
				<AutocompleteInput
					optionText="name"
					emptyText={translate("resources.bookmaker-deals.fields.users.all")}
				/>
			</ReferenceInput>
			<NumberInput
				source="percentage_change"
				InputProps={{
					startAdornment: <InputAdornment position="start">%</InputAdornment>,
				}}
			/>
		</SimpleForm>
	);
};
export default DuplicateForm;
